import React, { useEffect, useState } from "react";
import { RxCross2 } from "react-icons/rx";
import { AiOutlineMail } from "react-icons/ai";
import { VscSend } from "react-icons/vsc";
import { resultsData } from "../data/resultsData";
import PropTypes from "prop-types";
import Button from "../../../components/Button";

import "./ResultsEmailForm.css";

export default function EmailResultsForm({
  hideEmail,
  totalAssessment,
  formattedDate,
}) {
  const [submitButtonDisabled, setSubmitButtonDisabled] = useState(true);
  const [errorMessage, setErrorMessage] = useState("");
  const [success, setSuccess] = useState("");
  const [formState, setFormState] = useState({
    email: "",
    username: "",
  });
  const [isSending, setIsSending] = useState(false);
  const [templateAwakeness, setTemplateAwakeness] = useState("");
  const [templatePerspective, setTemplatePerspective] = useState("");

  const handleChange = (e) => {
    setErrorMessage("");
    setIsSending(false);
    const { name, value } = e.target;
    // Update the form state
    setFormState((prevState) => ({
      ...prevState,
      [name]: value,
    }));
    // Enable/disable submit button based on email and username values
    const isFormValid =
      (name === "email" ? value : formState.email) &&
      (name === "username" ? value : formState.username);
    setSubmitButtonDisabled(!isFormValid);
  };

  const sendEmail = async (e) => {
    e.preventDefault();
    setIsSending(true);
    const isValidEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formState.email);
    console.log("is valid: ", isValidEmail);
    if (!isValidEmail) {
      setErrorMessage("Invalid email format");
      setSubmitButtonDisabled(true);
      setIsSending(false);
      return;
    }
    const apiUrl =
      import.meta.env.MODE === "development"
        ? "http://127.0.0.1:5001/essence-9f702/us-central1/sendEmail"
        : "https://sendemail-yo7s25d5wq-uc.a.run.app"; // Deployed URL

    // const apiUrl =
    //   process.env.NODE_ENV === "development"
    //     ? "http://127.0.0.1:5001/essence-9f702/us-central1/sendEmail"
    //     : "https://sendemail-yo7s25d5wq-uc.a.run.app"; // Deployed URL
    // console.log(import.meta.env.MODE);
    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          to: formState.email,
          subject: "esa44",
          templateId: "d-d135af506f904cb791170030ea4c5f26",
          dynamicTemplateData: {
            username: formState.username,
            date: formattedDate,
            templateAssessment: totalAssessment,
            awakeness: templateAwakeness,
            perspective: templatePerspective,
          },
        }),
      });
      await response.json();
      if (response.ok) {
        setErrorMessage("");
        setSuccess("Email sent successfully");
        setSubmitButtonDisabled(true);
        setFormState({
          email: "",
          username: "",
        });
        setTemplateAwakeness("");
        setTemplatePerspective("");
      }
    } catch {
      setErrorMessage("Failed to send email. Please try again.");
      setSubmitButtonDisabled(true);
    } finally {
      setIsSending(false);
    }
  };

  useEffect(() => {
    if (resultsData) {
      resultsData.forEach((result) => {
        if (
          totalAssessment >= result.minPercentage &&
          totalAssessment <= result.maxPercentage
        ) {
          setTemplatePerspective(result.perspective);
          setTemplateAwakeness(result.awakeness);
        }
      });
    }
  }, [totalAssessment, resultsData]);

  return (
    <div
      className="allmailform-container fade-in-form"
      data-testid="email-form"
    >
      <div className="slide-inner">
        <div className="close-container">
          <RxCross2
            onClick={() => hideEmail(false)}
            style={{
              color: "white",
              width: "25px",
              height: "25px",
              cursor: "pointer",
            }}
          />
        </div>
        <div className="email-form-container">
          <div className="email-form-container-left">
            <div className="go-mail-div">
              <AiOutlineMail className="go-mail" alt="email logo" />
            </div>
            <h2 className="form-message-title">Inbox Results</h2>
            <p className="form-message">
              To receive your ESA44 results via email, please fill out the form.
            </p>
          </div>
          <form className="email-form">
            <label htmlFor="username-input" className="form-label">
              First Name
            </label>
            <br />
            <input
              className="form-input"
              id="username-input"
              type="text"
              placeholder="enter your first name"
              autoComplete="on"
              name="username"
              value={formState.username || ""}
              onChange={handleChange}
              aria-invalid={!!errorMessage}
            />
            <br />
            <label htmlFor="email-input" className="form-label">
              Email Address
            </label>
            <br />
            <input
              className="form-input"
              id="email-input"
              type="email"
              placeholder="enter your email address"
              autoComplete="on"
              name="email"
              value={formState.email || ""}
              onChange={handleChange}
              aria-invalid={!!errorMessage}
            />
            <br />
            {errorMessage && (
              <p aria-live="polite" className="error-message">
                {errorMessage}
              </p>
            )}
            {success && (
              <p aria-live="polite" className="success">
                {success}
              </p>
            )}
            <br />
            {isSending ? (
              <div className="sending-email" aria-label="Send email">
                <VscSend className="send-icon" />
              </div>
            ) : (
              <Button
                role="button"
                buttonType="submit"
                handleSubmit={sendEmail}
                // handleSubmit={() => setIsSending(true)} for testing
                buttonLoading={isSending}
                buttonDisabled={submitButtonDisabled}
              >
                SUBMIT
              </Button>
            )}
          </form>
        </div>
      </div>
    </div>
  );
}

EmailResultsForm.propTypes = {
  hideEmail: PropTypes.func.isRequired,
  totalAssessment: PropTypes.number.isRequired,
  formattedDate: PropTypes.string.isRequired,
};
